import "./Modal.scss";
import "./EditTimeSlotsModal.scss";
import { useEffect } from "react";

function EditTimeSlotsModal({
  editTimeSlotsModal,
  editTimeSlotsList,
  editSummerTimeSlotsList,
  setEditSummerTimeSlotsList,
  handleTimeSlotChange,
  onClose,
  onSaveTimeSlots,
}) {
  useEffect(() => {
    if (editTimeSlotsModal) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [editTimeSlotsModal]);

  if (!editTimeSlotsModal) return null;

  return (
    <div
      className="popup-overlay-admin"
      onClick={(e) =>
        e.target.classList.contains("popup-overlay-admin") && onClose()
      }
    >
      <div className="popup-content large">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>Edit Time Slots (5 Total)</h1>

        <div className="time-slots-edit">
          {/* Normal Season Slots */}
          {editTimeSlotsList.map((slot, idx) => (
            <div key={`normal-${idx}`} className="time-slot-row normal-slot">
              <p className="slot-label">Normal Season - Slot {idx + 1}</p>
              <label>
                Label
                <input
                  value={slot.label}
                  onChange={(e) => handleTimeSlotChange(idx, "label", e.target.value)}
                />
              </label>
              <label>
                Start Time
                <input
                  type="time"
                  value={slot.start_time}
                  onChange={(e) => handleTimeSlotChange(idx, "start_time", e.target.value)}
                />
              </label>
              <label>
                End Time
                <input
                  type="time"
                  value={slot.end_time}
                  onChange={(e) => handleTimeSlotChange(idx, "end_time", e.target.value)}
                />
              </label>
            </div>
          ))}

          {/* Summer Season Slots */}
          {editSummerTimeSlotsList.map((slot, idx) => (
            <div key={`summer-${idx}`} className="time-slot-row summer-slot">
              <p className="slot-label">Summer Season - Slot {idx + 1}</p>
              <label>
                Label
                <input
                  value={slot.label}
                  onChange={(e) => {
                    setEditSummerTimeSlotsList((prev) => {
                      const updated = [...prev];
                      updated[idx] = { ...updated[idx], label: e.target.value };
                      return updated;
                    });
                  }}
                />
              </label>
              <label>
                Start Time
                <input
                  type="time"
                  value={slot.start_time}
                  onChange={(e) => {
                    setEditSummerTimeSlotsList((prev) => {
                      const updated = [...prev];
                      updated[idx] = { ...updated[idx], start_time: e.target.value };
                      return updated;
                    });
                  }}
                />
              </label>
              <label>
                End Time
                <input
                  type="time"
                  value={slot.end_time}
                  onChange={(e) => {
                    setEditSummerTimeSlotsList((prev) => {
                      const updated = [...prev];
                      updated[idx] = { ...updated[idx], end_time: e.target.value };
                      return updated;
                    });
                  }}
                />
              </label>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={onSaveTimeSlots}>
            Save Time Slots
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTimeSlotsModal;
